import {useEffect, useRef, useState} from 'react';

type PositionType = 'top' | 'bottom' | 'left' | 'right';

const useReposition = (initialPosition: PositionType, parent, animationDistance: number) => {
  const ref: any = useRef();
  const [position, setPosition] = useState<PositionType>(initialPosition);
  const [offset, setOffset] = useState(0);

  const reposition = () => {
    if (!ref) return;
    const refRect = ref.current.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const offset = {
      top: refRect.top - animationDistance - parentRect.top,
      right: parentRect.right - refRect.right - animationDistance,
      bottom: parentRect.bottom - refRect.bottom - animationDistance,
      left: refRect.left - animationDistance - parentRect.left,
    };

    // set opposite position if not enough space
    if (position === 'top' && offset.top < 0) {
      setPosition('bottom');
    } else if (position === 'bottom' && offset.bottom < 0) {
      setPosition('top');
    } else if (position === 'left' && offset.left < 0) {
      setPosition('right');
    } else if (position === 'right' && offset.right < 0) {
      setPosition('left');
    }

    // calculate shifting
    if (position === 'top' || position === 'bottom') {
      if (offset.right < 0) {
        setOffset(offset.right);
      } else if (offset.left < 0) {
        setOffset(-offset.left);
      } else {
        setOffset(0);
      }
    } else {
      if (offset.top < 0) {
        setOffset(-offset.top);
      } else if (offset.bottom < 0) {
        setOffset(offset.bottom);
      } else {
        setOffset(0);
      }
    }
  };

  useEffect(() => {
    reposition();
  }, [ref]);

  return {ref, position, offset};
};

export default useReposition;
